export enum enumBrokerMessageDirection {
  TO_USER,
  TO_BROKER,
}
